import React, { useState } from 'react';
import { Container, Grid, Stack, Typography, Autocomplete, TextField } from '@mui/material';

// Mock data for the dropdowns
// prettier-ignore
const widgetOrPageOptions = [
    'adminFeedback', 'announcements', 'cct', 'courseTutoring', 'impersonation', 'itsHelp', 'landing', 'mobile', 'myAdvisingTeam', 'myApps', 'myBalances', 'myBookmarks', 'myCourses', 'myDining', 'myNews', 'myPrograms', 'mySchedule', 'myWaitlist', 'placesAndHours', 'resources', 'safety', 'settings', 'setUp', 'ssa', 'systemsStatus', 'universityLibraries', 'widget', 'secondaryPage'
].sort();

// prettier-ignore
const componentOrHtmlTagOptions = [
    'actionsButton', 'addressBox', 'alphabetList', 'appCard', 'appTitle', 'balance', 'bannerInfo', 'category', 'contactCard', 'contactCardAvatar', 'contactList', 'content', 'error', 'feedbackButton', 'item', 'itemBox', 'likert', 'mapLocation', 'masterDetails', 'menuToggleButton', 'nav', 'note', 'operatingHours', 'placeCard', 'quickTip', 'scheduleMeeting', 'scrollThumb', 'signIn', 'statusAlert', 'time', 'toast', 'info', 'errorCode', 'signInButton', 'floatLabelInput', 'newsItem', 'navBarButton', 'setUpDialog',

    // HTML Tags
    'head', 'title', 'base', 'link', 'meta', 'style', 'body', 'address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'main', 'nav', 'section', 'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'ol', 'p', 'pre', 'ul', 'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn', 'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr',

    // MUI Components 
   'accordion', 'accordionDetails', 'accordionSummary', 'alert', 'alertTitle', 'appBar', 'autcomplete', 'avatar', 'avatarGroup', 'backdrop', 'badge', 'bottomNavigation', 'bottomNavigationAction', 'box', 'breadcrumbs', 'button', 'buttonBase', 'buttonGroup', 'card', 'cardActionArea', 'cardActions', 'cardContent', 'cardHeader', 'cardMedia', 'checkbox', 'chip', 'circularProgress', 'clickAwayListener', 'collapse', 'container', 'cssBaseline', 'dataGrid', 'dataGridPro', 'dialog', 'dialogActions', 'dialogContent', 'dialogContentText', 'dialogTitle', 'divider', 'drawer', 'fab', 'fade', 'filledInput', 'formControl', 'formControlLabel', 'formGroup', 'formHelperText', 'formLabel', 'grid', 'grow', 'hidden', 'icon', 'iconButton', 'imageList', 'imageListItem', 'imageListItemBar', 'input', 'inputAdornment', 'inputBase', 'inputLabel', 'linearProgress', 'link', 'list', 'listItem', 'listItemAvatar', 'listItemButton', 'listItemIcon', 'listItemSecondaryAction', 'listItemText', 'listSubheader', 'menu', 'menuItem', 'menuList', 'mobileStepper', 'modal', 'modalUnstyled', 'nativeSelect', 'noSsr', 'outlinedInput', 'pagination', 'paginationItem', 'paper', 'popover', 'popper', 'portal', 'radio', 'radioGroup', 'rating', 'scopedCssBaseline', 'select', 'skeleton', 'slider', 'snackbar', 'snackbarContent', 'speedDial', 'speedDialAction', 'speedDialIcon', 'stack', 'step', 'stepButton', 'stepConnector', 'stepContent', 'stepIcon', 'stepLabel', 'stepper', 'styled', 'swipeableDrawer', 'switch', 'tab', 'table', 'tableBody', 'tableCell', 'tableContainer', 'tableFooter', 'tableHead', 'tablePagination', 'tableRow', 'tableSortLabel', 'tabs', 'tabScrollButton', 'textField', 'toggleButton', 'toggleButtonGroup', 'toolbar', 'tooltip', 'touchRipple', 'typography', 'useAutocomplete', 'zoom',

].sort();

// prettier-ignore
const subcomponentOrHtmlTagOptions = [
    'good', 'bad', 'text', 'favorite', 'low', 'optional', 'primary', 'required', 'secondary', 'step1', 'tertiary', 'unknown', 'title', 'wrapper', 'error', 'scrollButton', 'letterButton', 'secondaryTab'
].sort();

// prettier-ignore
const cssPropertyOptions = [
    'color', 'background-color', 'font-size', 'font-family', 'margin', 'padding', 'border', 'border-radius', 'width', 'height', 'max-width', 'max-height', 'min-width', 'min-height', 'display', 'position', 'top', 'right', 'bottom', 'left', 'float', 'clear', 'overflow', 'text-align', 'vertical-align', 'line-height', 'letter-spacing', 'white-space', 'text-decoration', 'text-transform', 'z-index', 'opacity', 'visibility', 'content', 'background-image', 'background-position', 'background-repeat', 'background-size', 'box-shadow', 'transition', 'transform', 'cursor', 'align-items', 'justify-content', 'flex', 'flex-direction', 'flex-wrap', 'grid-template-columns', 'grid-template-rows', 'grid-column', 'grid-row', 'grid-area', 'column-count', 'column-gap', 'list-style', 'font-weight', 'font-style', 'font-variant', 'font-stretch'
];

const stateOptions = [
  'hover',
  'active',
  'disabled',
  'closed',
  'open',
  'success',
  'error',
  'small',
  'mobile',
  'disabled--hover',
];

function VariableNames() {
  const [namingParts, setNamingParts] = useState({
    widgetOrPage: '',
    componentOrHtmlTag: '',
    subcomponentOrHtmlTag: '',
    cssProperty: '',
    state: '',
  });

  const handleChange = (field) => (event, newValue) => {
    setNamingParts((prevParts) => ({
      ...prevParts,
      [field]: newValue || '',
    }));
  };

  const buildVariableName = () => {
    const { widgetOrPage, componentOrHtmlTag, subcomponentOrHtmlTag, cssProperty, state } =
      namingParts;

    if (!componentOrHtmlTag && !cssProperty) {
      return (
        <Typography variant="p" className="myOdu__error">
          Component or HTML tag AND css property required to build variable name.
        </Typography>
      );
    } else if (!componentOrHtmlTag) {
      return (
        <Typography variant="p" className="myOdu__error">
          Component or HTML tag required to build variable name.
        </Typography>
      );
    } else if (!cssProperty) {
      return (
        <Typography variant="p" className="myOdu__error">
          Css property required to build variable name.
        </Typography>
      );
    }

    return [
      widgetOrPage && `${widgetOrPage}___`,
      componentOrHtmlTag && `${componentOrHtmlTag}__`,
      subcomponentOrHtmlTag && `${subcomponentOrHtmlTag}_`,
      `${cssProperty}`,
      state && `--${state}`,
    ]
      .filter(Boolean)
      .join('');
  };

  return (
    <>
      <Typography variant="h2">Variable Naming Convention</Typography>

      <code>widgetOrPage___componentOrHtmlTag__subcomponentOrHtmlTag_css-property--state</code>

      <ul className="mt-4">
        <li>
          <Typography variant="p">
            <strong>widgetOrPage___</strong> (Optional) Widget from dashboard or secondary page in
            camelCase followed by 3 underbars
          </Typography>
        </li>
        <li>
          <Typography variant="p">
            <strong>componentOrHtmlTag__</strong>
            Component specifically written for Portal, MUI component or HTML tag in camelCase
            followed by 2 underbars
          </Typography>
        </li>
        <li>
          <Typography variant="p">
            <strong>subcomponentOrModifierOrHtmlTag-</strong> (Optional) Subcomponent specifially
            written for Portal, modifier to describe component, section of component or HTML tag in
            camelCase followed by 1 underbar.
          </Typography>
        </li>
        <li>
          <Typography variant="p">
            <strong>css-property</strong>&nbsp; Proper css propertly with terms separated with
            hyphens.
          </Typography>
        </li>
        <li>
          <Typography variant="p">
            <strong>--state</strong> (Optional) Double hyphens followed by modifier to differentiate
            variable. If there is more than 1 state, concatonate with double hyphens.
          </Typography>
        </li>
      </ul>

      <Typography variant="h3" gutterBottom sx={{ mt: 4 }}>
        Variable Name Builder
      </Typography>

      <Stack className="w-100" spacing={3} direction="row">
        <Autocomplete
          options={widgetOrPageOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Widget or Page (Optional)"
              variant="outlined"
              //TODO: make style and do this right
              sx={{
                '& .MuiInputBase-root': { fontSize: '0.8rem' },
                '& .MuiInputLabel-root': { fontSize: '0.8rem' },
              }}
            />
          )}
          onChange={handleChange('widgetOrPage')}
          className="w-100"
        />

        <Autocomplete
          options={componentOrHtmlTagOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Component or HTML Tag"
              variant="outlined"
              sx={{
                '& .MuiInputBase-root': { fontSize: '0.8rem' },
                '& .MuiInputLabel-root': { fontSize: '0.8rem' },
              }}
            />
          )}
          onChange={handleChange('componentOrHtmlTag')}
          className="w-100"
        />

        <Autocomplete
          options={subcomponentOrHtmlTagOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Subcomponent, Modifier or HTML Tag (Optional)"
              variant="outlined"
              sx={{
                '& .MuiInputBase-root': { fontSize: '0.8rem' },
                '& .MuiInputLabel-root': { fontSize: '0.8rem' },
              }}
            />
          )}
          onChange={handleChange('subcomponentOrHtmlTag')}
          className="w-100"
        />

        <Autocomplete
          options={cssPropertyOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              label="CSS Property"
              variant="outlined"
              sx={{
                '& .MuiInputBase-root': { fontSize: '0.8rem' },
                '& .MuiInputLabel-root': { fontSize: '0.8rem' },
              }}
            />
          )}
          onChange={handleChange('cssProperty')}
          className="w-100"
        />

        <Autocomplete
          options={stateOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              label="State (Optional)"
              variant="outlined"
              sx={{
                '& .MuiInputBase-root': { fontSize: '0.8rem' },
                '& .MuiInputLabel-root': { fontSize: '0.8rem' },
              }}
            />
          )}
          onChange={handleChange('state')}
          className="w-100"
        />
      </Stack>
      <Typography variant="h3" sx={{ mt: 4 }}>
        Variable Name
      </Typography>

      <Typography variant="p">{buildVariableName()}</Typography>
    </>
  );
}

export default VariableNames;
